import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useDropzone } from 'react-dropzone';
import { Link } from 'react-router-dom';
import ReactSelect from 'react-select';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';

const generateData = (length = 12) => {
  const value = [];
  for (let i = 1; i <= length; i++) {
    const data = { value: i, label: i };
    value.push(data);
  }
  return value;
};

const selectYearForMovie = [];
for (let i = 1990; i <= new Date().getFullYear(); i++) {
  const data = { value: i, label: i };
  selectYearForMovie.unshift(data);
}

const GiftAidEligibility = () => {
  const [date, setDate] = useState(null);
  const [day, setDay] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [score, setScore] = useState(null);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title as={Flex} className="fw-medium justify-content-between">
          <p className="mb-0">Gift Aid Eligibility</p>
          <Form.Check
            type="switch"
            id="defaultSwitch"
            label=""
            defaultChecked
          />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={12}>
            <Row>
              <Form.Group as={Col} md={4}>
                <DatePicker
                  required
                  selected={date}
                  onChange={date => setDate(date)}
                  className="form-control border-0 shadow-none"
                  placeholderText="DD-MM-YYYY"
                  timeIntervals={5}
                  dateFormat="dd-MM-yyyy"
                  fixedHeight
                />
              </Form.Group>
            </Row>
            <hr />
            <Row>
              <Col md={12}>
                <Form.Label>
                  Valid Form<span className="text-danger">*</span>
                </Form.Label>

                <Row className="g-3 mb-3">
                  <Form.Group as={Col} md={4}>
                    <ReactSelect
                      required
                      closeMenuOnSelect={true}
                      options={generateData(31)}
                      placeholder="Back Date"
                      classNamePrefix="react-select"
                      defaultInputValue={new Date().getDate()}
                      value={day}
                      onChange={value => setDay(value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Required
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md={2}>
                    <ReactSelect
                      required
                      closeMenuOnSelect={true}
                      options={generateData(12)}
                      placeholder="Month"
                      classNamePrefix="react-select"
                      defaultInputValue={new Date().getMonth() + 1}
                      value={month}
                      onChange={value => setMonth(value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Required
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md={4}>
                    <ReactSelect
                      required
                      closeMenuOnSelect={true}
                      options={selectYearForMovie}
                      placeholder="Back Year"
                      classNamePrefix="react-select"
                      defaultInputValue={new Date().getFullYear()}
                      value={year}
                      onChange={value => setYear(value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Required
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>

                <Form.Group as={Col} md={4}>
                  <Form.Label>
                    Deceleration Source<span className="text-danger">*</span>
                  </Form.Label>
                  <ReactSelect
                    required
                    closeMenuOnSelect={true}
                    options={generateData(100)}
                    placeholder=""
                    classNamePrefix="react-select"
                    value={score}
                    onChange={value => setScore(value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Required
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <hr />
            <Flex justifyContent={'between'}>
              <Button
                variant="light"
                className="bg-transparent border-0 fs--1 fs-md-0 shadow-none text-primary p-1"
              >
                + Add Note
              </Button>

              <Button
                as={Link}
                to="/"
                target="_blank"
                variant="link"
                size="sm"
                className="ps-0"
              >
                <FontAwesomeIcon
                  icon="exclamation-circle"
                  className="me-2 fs--2"
                />
                <span className="text-900">Read Conditions</span>
              </Button>
            </Flex>

            <div className="mt-2">
              <div
                {...getRootProps({ className: 'dropzone-area h-auto py-6' })}
              >
                <input {...getInputProps({ multiple: false })} />
                <Flex
                  justifyContent="center"
                  alignItems={'center'}
                  direction={'column'}
                >
                  <img src={cloudUpload} alt="" width={60} className="me-2" />
                  <p className="fs-0 mb-0 text-700">Drop your file here</p>
                </Flex>
              </div>
              <div className="mt-3">
                {acceptedFiles.length > 0 && (
                  <>
                    <h6>File</h6>
                    <ul>{files}</ul>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default GiftAidEligibility;
